import { render } from "./AnnotationSidebar.vue?vue&type=template&id=08fbfc41&bindings={}"
import script from "./AnnotationSidebar.vue?vue&type=script&lang=js"
export * from "./AnnotationSidebar.vue?vue&type=script&lang=js"

import "./AnnotationSidebar.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script